import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

const Title = (props) => {
  return (
    <Typography variant="h5" color="primary" gutterBottom>
      {props.children}
    </Typography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};

export const H1 = (props) => {
    return (
      <Typography variant="h6" color="primary" gutterBottom>
        {props.children}
      </Typography>
    );
  }

export default Title;
